import Column from '@components/Column';
import Text from '@components/Text';
import styled from '@emotion/styled';
import { OrderReceiptResponse } from '@models/order';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import ReceiptDivider from '../ReceiptDivider';

interface Props {
    receipt: OrderReceiptResponse;
}

function Items({ receipt }:Props) {
    const { t } = useTranslation('orderReceipt');
    const { order } = receipt;
    const { orderLines, orderType, discounts } = order;
    const isInShop = orderType === 'IN_SHOP';
    return (
        <Column as='section' fullWidth>
            <Grid>
                <Text>{t('items.menu')}</Text>
                <Text>{t('items.quantity')}</Text>
                <Text>{t('items.amount')}</Text>
            </Grid>
            <ReceiptDivider/>
            <Column spacing={5} fullWidth>
                {orderLines.map((orderLine, i) => {
                    const {
                        itemName, itemPrice, inShopPrice, qty, orderOptions, id,
                    } = orderLine;
                    const lineDiscounts = discounts
                        .filter((discount) => discount.orderLineId === id);
                    const displayPrice = isInShop
                        ? itemPrice + (inShopPrice ?? 0)
                        : itemPrice;
                    return (
                        <Grid key={`orderLine ${i}`} >
                            <Text size='title' fontWeight='bold'>{itemName}</Text>
                            <Text size='title' fontWeight='bold'>{qty.toLocaleString()}</Text>
                            <Text size='title' fontWeight='bold'>{displayPrice.toLocaleString()}</Text>
                            {orderOptions?.sort((a, b) => a.optionName.localeCompare(b.optionName))
                                .map((orderOption, j) => {
                                    const { optionName, optionPrice, qty: optionQty } = orderOption;
                                    return (
                                        <Fragment key={`orderOption ${i}-${j}`}>
                                            <Text>- {optionName}</Text>
                                            <Text>{optionQty.toLocaleString()}</Text>
                                            <Text>{optionPrice.toLocaleString()}</Text>
                                        </Fragment>
                                    );
                                })}
                            {lineDiscounts?.map((lineDiscount, idx) => (
                                <Fragment key={`${id}_${idx}`}>
                                    <Text>{lineDiscount.couponName}</Text>
                                    <Text>1</Text>
                                    <Text>-{lineDiscount.discountAmount.toLocaleString()}</Text>
                                </Fragment>
                            ))}
                        </Grid>
                    );
                })}
            </Column>
            <ReceiptDivider/>
        </Column>
    );
}

const Grid = styled.div`
    display: grid;
    grid-template-columns: 1fr 36px 90px;
    row-gap: 2px;
    width: 100%;

    & *:nth-of-type(3n + 2) {
        text-align: center;
    }

    & *:nth-of-type(3n) {
        text-align: right;
    }

    & *:nth-of-type(3n + 1) {
        text-align: left;
    }
`;

export default Items;
